<div class="title">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.TITLE' | translate }}
</div>
<div class="subtitle">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.DESCRIPTION' | translate }}
</div>

<div class="settings">
  <meeting-scheduler-integration-selection
    [initialSelection]="initialServiceSelection$ | async"
    (integrationSelected)="onIntegrationSelected($event)"
  ></meeting-scheduler-integration-selection>
  @if (selection$ | async; as selection) {
    @if (!selection.isConnected) {
      <div class="meeting-app-actions">
        @if (selection.service === zoom) {
          <meeting-scheduler-connect-with-zoom-button [serviceKey]="serviceKey" [isMeetingApp]="true">
          </meeting-scheduler-connect-with-zoom-button>
        }
        @if (selection.service === meet) {
          <meeting-scheduler-connect-with-google-button
            [serviceKey]="serviceKey"
            [isMeetingApp]="true"
          ></meeting-scheduler-connect-with-google-button>
        }
        @if (selection.service === microsoft) {
          <meeting-scheduler-connect-with-microsoft-button
            [serviceKey]="serviceKey"
            [isMeetingApp]="true"
          ></meeting-scheduler-connect-with-microsoft-button>
        }
      </div>
    }
    @if (selection.isConnected) {
      <ng-content></ng-content>
    }
  }
</div>
